import { Input } from 'modules/common/components';
import { ComponentProps, FC } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

type PropTypes = {
  controlled: UseControllerProps<any>;
} & ComponentProps<typeof Input>;

const ControlledInput: FC<PropTypes> = ({ controlled, ...restProps }) => {
  const { field } = useController(controlled);

  return <Input {...field} {...restProps} />;
};

export default ControlledInput;
